// extracted by mini-css-extract-plugin
module.exports = {"donation":"l7","donationIcon":"l8","donationTitle":"l9"};